"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("../../styles/components/switch.less");
const CHECKED_DEFAULT = false;
const READONLY_DEFAULT = false;
const ROUND_DEFAULT = false;
const ON_CLICK_DEFAULT = null;
const Switch = ({ checked = CHECKED_DEFAULT, onClick = ON_CLICK_DEFAULT, readOnly = READONLY_DEFAULT, round = ROUND_DEFAULT, }) => {
    const handleClick = (0, react_1.useCallback)(() => {
        if (typeof onClick !== 'function') {
            return;
        }
        if (!readOnly) {
            onClick(!checked);
        }
    }, [readOnly, onClick, checked]);
    return (react_1.default.createElement("div", { onClick: handleClick, className: (0, classnames_1.default)('on-off-switch', round && 'round-on-off-switch', { checked, readOnly }) },
        react_1.default.createElement("div", { className: "onoffswitch-label" },
            react_1.default.createElement("span", { className: "onoffswitch-inner" },
                react_1.default.createElement("span", { className: (0, classnames_1.default)('inner-on', round && 'round-inner-on') }, !round && 'YES'),
                react_1.default.createElement("span", { className: (0, classnames_1.default)('inner-off', round && 'round-inner-off') }, !round && 'NO')),
            react_1.default.createElement("span", { className: "onoffswitch-switch" }))));
};
exports.default = Switch;
//# sourceMappingURL=switch.js.map